/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signinfailed2Inputs */

const zh_auth_signinfailed2 = /** @type {(inputs: Auth_Signinfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录失败`)
};

const en_auth_signinfailed2 = /** @type {(inputs: Auth_Signinfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in failed`)
};

const es_auth_signinfailed2 = /** @type {(inputs: Auth_Signinfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al iniciar sesión`)
};

/**
* | output |
* | --- |
* | "Sign in failed" |
*
* @param {Auth_Signinfailed2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_signinfailed2 = /** @type {((inputs?: Auth_Signinfailed2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signinfailed2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_signinfailed2(inputs)
	if (locale === "en") return en_auth_signinfailed2(inputs)
	return es_auth_signinfailed2(inputs)
});
export { auth_signinfailed2 as "auth_signInFailed" }